const Home = () => {
  return (
    <section>
      <h1>Chat</h1>
    </section>
  );
};

export default Home;
